// extracted by mini-css-extract-plugin
module.exports = {"pointerWrapper":"Pointer-module--pointerWrapper--oZtp7","page":"Pointer-module--page--1hZRY","fill":"Pointer-module--fill--2SudN","line":"Pointer-module--line--3TLi_"};